import React from 'react';
import styles from './styles/PageTitle.module.css';

const PageTitle = ({ src, title }) => {
  return (
    <div className={styles.pageTitle}>
      <img src={src} alt={title} />
      <h1>{title}</h1>
    </div>
  );
};

export default PageTitle;